module.exports = __webpack_public_path__ + "static/media/user.11a8c02f.svg";